import { render, staticRenderFns } from "./Congratulations.vue?vue&type=template&id=f87c1846&scoped=true&"
import script from "./Congratulations.vue?vue&type=script&lang=js&"
export * from "./Congratulations.vue?vue&type=script&lang=js&"
import style0 from "./Congratulations.vue?vue&type=style&index=0&id=f87c1846&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87c1846",
  null
  
)

export default component.exports